export default "<img data-bind=\"register: initImage\" />\n"